import InputSelect from './InputSelect'

export default InputSelect



// WEBPACK FOOTER //
// ./src/components/InputSelect/index.js